"use client";

// Консольные экраны портала (список приложений, создание, карточка) —
// только для залогиненных: гость уходит в Passport-флоу с возвратом на
// dev-origin. Документация лежит вне этой группы и остаётся публичной.
import { DevAuthGate } from "@/components/dev/dev-auth-gate";

export default function DevConsoleLayout({ children }: { children: React.ReactNode }) {
  return <DevAuthGate>{children}</DevAuthGate>;
}
